<div (click)="onDialogClick()" class="modal-container">
  <p class="title-center">{{ message }}</p>
</div>

